import { ChevronDownIcon, ListIcon } from "@lifesg/react-icons";
import BasicLink from "app/components/basic/Link";
import { ILinkGroup, ILinkItem } from "app/utils/interfaces";

export const generateLinks = (links: ILinkItem[], currentActiveLink: string, type: string): JSX.Element[] =>
	links.map((item: ILinkItem, index: number) => {
		const id = `internal-menu-${type}--${index}`;
		let GeneratedElement: JSX.Element;
		if (item.name === currentActiveLink) {
			GeneratedElement = (
				<div key={id} id={id} className="internal-menu--active--link">
					{item.name}
				</div>
			);
		} else {
			GeneratedElement = (
				<BasicLink key={id} type="no-underline-link" id={id} href={item.path} name={item.name} />
			);
		}
		return GeneratedElement;
	});

export const generateMenuList = (linkGroups: ILinkGroup[], currentActiveLink: string, type: string): JSX.Element[] => {
	const generatedGroupLinks: JSX.Element[] = [];
	for (const group of linkGroups) {
		let index = 0;
		generatedGroupLinks.push(
			<div className="internal-menu__group" key={`internal-menu__group--${index}`}>
				{group.title && <div className="internal-menu__group__title">{group.title}</div>}
				<div className="internal-menu__group__links">{generateLinks(group.links, currentActiveLink, type)}</div>
			</div>,
		);

		index++;
	}
	return generatedGroupLinks;
};

export const generatePanelTitleElement = (
	type: "accordion" | "list",
	title: string,
	classNamePrefix = "internal-menu",
): JSX.Element => {
	return (
		<button className={`${classNamePrefix}--${type}--title`}>
			<div className={`${classNamePrefix}--${type}--title--list-icon`}>
				<ListIcon />
			</div>
			<div className={`${classNamePrefix}--${type}--title--label`}>{title}</div>
			{type === "accordion" && (
				<span className={`${classNamePrefix}--${type}--title--indicator icon`}>
					<ChevronDownIcon />
				</span>
			)}
		</button>
	);
};
